
import { defineComponent, PropType } from 'vue'
import Category from './Category.vue'
import useStore from './../store'
import { ICategory, IBottomLink } from './../type'

const store = useStore(window.pinia)

export default defineComponent({
    props: {
        category: {
            type: Object as PropType<ICategory>,
            required: true,
        },
        links: {
            type: Array as PropType<IBottomLink[]>,
            default: () => [],
        },
        isActive: {
            type: Boolean as PropType<boolean>,
        },
    },
    computed: {
        hasLinks () {
            return this.links.length > 0
        },
        hasCategories () {
            return this.categories.length > 0
        },
        categories () {
            return this.category.category
        },
    },
    // mounted () {
    //     this.$nextTick(function () {
    //         const positionLeftAndRight = (window.outerWidth - this.$refs.container.offsetWidth) / 2 * -1; // (1920 - 1280) / 2 * -1 => left: -470px and right: -470px
    //         this.$refs.container.style.left = positionLeftAndRight + 'px';
    //         this.$refs.container.style.right = positionLeftAndRight + 'px';
    //     });
    // },
    methods: {
        mouseover () {
            // If screen more than 980px. Stop opening if mouse out of the menu.
            if (!window.matchMedia('(max-width: 980px)').matches) {
                store.stopOpening()
            }
        },
    },
    components: {
        Category,
    },
})
